<template>
  <div
    v-if="hasMultiplePages"
    class="pagination"
  >
    <DeactivatableLink
      :disabled="!hasPrevPage"
      :emit-only-click="emitOnlyClick"
      :to="prevPageUrl"
      class="pagination__link pagination__link--prev"
      disabled-class="pagination__link--disabled"
      @click="emitClick"
    >
      <Arrow
        direction="left"
        class="pagination__icon pagination__icon--prev"
        tag="span"
      />
      Zurück
    </DeactivatableLink>

    <LinkPaginator
      class="pagination__paginator"
      :current-page="currentPage"
      :emit-only-click="emitOnlyClick"
      :total-pages="totalPages"
      :url="url"
      @click="emitClick"
    />

    <SelectPaginator
      class="pagination__selectbox"
      :current-page="currentPage"
      :emit-only-click="emitOnlyClick"
      :total-pages="totalPages"
      :url="url"
      @click="emitClick"
    />

    <DeactivatableLink
      :disabled="!hasNextPage"
      :emit-only-click="emitOnlyClick"
      :to="nextPageUrl"
      class="pagination__link pagination__link--next"
      disabled-class="pagination__link--disabled"
      @click="emitClick"
    >
      Weiter
      <Arrow
        direction="right"
        class="pagination__icon pagination__icon--next"
        tag="span"
      />
    </DeactivatableLink>
  </div>
</template>

<script>
import { Arrow } from '@i22-td-smarthome/component-library';
import DeactivatableLink from '@/components/deactivatable-link.vue';
import LinkPaginator from '@/components/link-paginator.vue';
import SelectPaginator from '@/components/select-paginator.vue';

export default {
  name: 'Pagination',
  components: {
    Arrow,
    DeactivatableLink,
    LinkPaginator,
    SelectPaginator,
  },
  props: {
    currentPage: {
      type: Number,
      required: true,
    },
    totalPages: {
      type: Number,
      required: true,
    },
    url: {
      type: Function,
      required: true,
    },
    emitOnlyClick: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['click'],
  data() {
    return {
      component: null,
    };
  },
  computed: {
    hasMultiplePages() {
      return this.totalPages > 1;
    },
    hasPrevPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.currentPage < this.totalPages;
    },
    prevPageUrl() {
      return this.url(this.currentPage - 1);
    },
    nextPageUrl() {
      return this.url(this.currentPage + 1);
    },
  },
  methods: {
    emitClick(target) {
      this.$emit('click', target);
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  grid-gap: $grid-base * 2;
  user-select: none;
  @include mq($mq-sm) {
    grid-gap: $grid-base * 3;
  }

  &__paginator {
    @include mq(false, $mq-sm - 1) {
      display: none;
    }
  }

  &__selectbox {
    @include mq($mq-sm) {
      display: none;
    }
  }

  &__icon {
    position: relative;
    color: currentColor;
    width: 0.6em;
    height: 0.6em;

    &--next {
      right: -5px;
    }

    &--prev {
      left: -5px;
    }
  }
}
</style>
